import { useContext } from 'react'
import PropTypes from 'prop-types'
import { BootstrapDataContext } from '../../contexts/'

const CheckboxProductCopy = ({ children }) => {
  const {
    key = {},
    isMobile = {}
  } = useContext(BootstrapDataContext)
  const shouldShowProductCopy = key === 'home' && !isMobile

  if (shouldShowProductCopy) {
    return 'Bundle + Save'
  }
  return children
}

CheckboxProductCopy.propTypes = {
  children: PropTypes.node
}

export default CheckboxProductCopy
